import React, {Fragment, useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Helmet} from 'react-helmet';
import {BrowserRouter, Switch, Route, matchPath} from 'react-router-dom';

import {ThemeProvider} from 'styled-components';
import commonHelmetJson from 'common-helmet-json';

import createStore from '@stencil/create-redux-store';
import Modal from '@stencil/modal';
import {defaultTheme} from '@stencil/build-theme';
import {GlobalStyles} from '@stencil/global-style';
import { loadableReady } from '@loadable/component'
import { RemoveParamInURL, removeTermsOfServiceFromURLAndRedirect } from '../../../verticals/mbus-seo/src/shared/SEOContainer/Common/utils';
// Common user widget integeration
// Ping did mount integeration
// Component did catch error tracking
// Modal support

const App = ({routes, store, theme, style}) => {
  let hideHeader = false;
  let hideFooter = false;
  let showModal = false;
  let footerType ='desktop';
  //seo adhoc task - remove PageSpeed=noscript in url query param and redirect to original url
  useEffect(()=>{
    let checkParamInURL = RemoveParamInURL('PageSpeed','')
    if(checkParamInURL && checkParamInURL.isPresent == true){
       window.history.pushState({}, document.title, window.location.pathname);
    }
    removeTermsOfServiceFromURLAndRedirect('') //function for google crawl issue in url,to remove /info/terms-of-services/ from url and redirect it to original url
  },[])
  const RouteComponent = props => {
    const {location} = props;
    const {pathname} = location;
    const previousLocationRef = useRef();
    useEffect(() => {
      previousLocationRef.current = location;
    });
    const previousLocation = previousLocationRef.current;
    routes.some(route => {
      const matchObj = matchPath(pathname, route);
      if (matchObj) {
        const {showHeader = true, showFooter = true, isModal = false,webType = 'desktop'} = route;
        hideHeader = !showHeader;
        hideFooter = !showFooter;
        showModal = isModal;
        footerType = webType
      }
      return matchObj;
    });
    return (
      <Fragment>
        {(showModal && (
          <Modal>
            <Switch>
              {routes
                .filter(route => route.isModal)
                .map(route => (
                  <Route {...route}/>
                ))}
            </Switch>
          </Modal>
        )) ||
          null}
        <Switch location={showModal ? previousLocation : location}>
          {routes
            .filter(route => !route.isModal)
            .map(route => (
              <Route {...route}/>
            ))}
        </Switch>
   
      </Fragment>
    );
  };

  let styleComponent = <GlobalStyles />;
  if (style) {
    styleComponent = style;
  }

  return (
    <ThemeProvider theme={theme}>
      <Helmet {...commonHelmetJson} />
      <Provider store={store}>
        {styleComponent}
        <BrowserRouter>
          <Route component={RouteComponent}/>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
};

export default function mountReactApp({
  routes,
  reducers,
  initialState = window.__initial_state__,
  theme,
  style,
}) {
  const store = createStore({reducers, initialState});
  const urlPath = window.location.pathname;
  const searchString = window.location.search;
  routes.some(route => {
    const matchObj = matchPath(urlPath, route);
    if (matchObj) {
      const {params = {}} = matchObj;
      const {populateStoreFromUrl = () => {}} = route;
      populateStoreFromUrl({params, searchString}, store.dispatch);
    }
    return matchObj;
  });
  loadableReady(() => {
    ReactDOM.hydrate(
      <App routes={routes} store={store} theme={theme || defaultTheme} style={style}/>,
      document.getElementById('root'),
    );
    window.pageSeen('TTI');

  }) 
};
